import { render } from "./RightSidebar.vue?vue&type=template&id=33191606"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/_partials/RightSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33191606"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33191606', __exports__)) {
    api.reload('33191606', __exports__)
  }
  
  module.hot.accept("./RightSidebar.vue?vue&type=template&id=33191606", () => {
    api.rerender('33191606', render)
  })

}


export default __exports__